/**
 * Formattazione generica (numeri, valuta, date), indipendente dal dominio
 * del modulo. Le etichette specifiche (tipologie, stati, ecc.) restano nel
 * file utils/format.js di ciascuna app, che ri-esporta queste funzioni.
 */
import { getLang } from '../i18n/LanguageContext';

export const fmtNum = (value, digits = 0) => {
  const num = Number(value);
  if (isNaN(num)) return '—';
  return num.toLocaleString(getLang() === 'en-GB' ? 'en-GB' : 'it-IT', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    useGrouping: true,
  });
};

export const fmtPct = (value, digits = 1) => {
  const num = Number(value);
  if (isNaN(num)) return '—';
  return fmtNum(num, digits) + '%';
};

export const fmtEuro = (value, digits = 0) => '€ ' + fmtNum(value, digits);

export const fmtDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  return d.toLocaleDateString(getLang() === 'en-GB' ? 'en-GB' : 'it-IT');
};

export const fmtDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d)) return String(value);
  return d.toLocaleString(getLang() === 'en-GB' ? 'en-GB' : 'it-IT', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
